import type { PostForgotPasswordRequest } from './types';
import type { GetSigninResponse } from '../get';
import { postGenericEndpoint, type PostGenericEndpointParams } from './post.api';

export const postForgotPassword = async ({ data, lang, token }: PostGenericEndpointParams<PostForgotPasswordRequest>): Promise<GetSigninResponse> => {
    return await postGenericEndpoint({
        data,
        lang,
        token,
        path: 'forgotten',
    });
};
